import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { buildQuery, useApi } from './client'

export type Alert = {
  id: string
  organizationId: string
  kind: string
  severity: 'warning' | 'critical'
  payload: {
    weekStart: string
    weekEnd: string
    projectedClose: number
    threshold: number
    horizonWeeks: number
  }
  acknowledgedAt: string | null
  createdAt: string
}

export type AlertsFilter = {
  status?: 'open' | 'all'
}

type AlertsResp = { items: Alert[] }

const ROOT = '/alerts'
const KEY = ['alerts'] as const

export function useAlerts(filter: AlertsFilter = {}) {
  const api = useApi()
  return useQuery({
    queryKey: [...KEY, 'list', filter.status],
    queryFn: () =>
      api<AlertsResp>(
        `${ROOT}${buildQuery({
          status: filter.status,
        })}`,
      ),
    refetchInterval: 60_000,
  })
}

export function useAcknowledgeAlert() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      api<Alert>(`${ROOT}/${id}/acknowledge`, { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
